import { pxToRem } from '@packages/themes/utils';
import { makeStyles } from '@/styles/v4/tss-react';

const AGREEMENTS_MAX_WIDTH_PX = 826;
const CONTINUE_BUTTON_WIDTH_PX = 300;

const useStyles = makeStyles({ name: 'SignAgreementsView' })(
  ({ breakpoints, spacing }) => ({
    header: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(0),
    },
    backButton: {
      alignSelf: 'flex-start',
    },
    heading: {
      [breakpoints.up('md')]: {
        textAlign: 'center',
      },
    },
    agreements: {
      width: '100%',
      maxWidth: pxToRem(AGREEMENTS_MAX_WIDTH_PX),
      alignSelf: 'center',
    },
    continueButton: {
      [breakpoints.up('md')]: {
        width: pxToRem(CONTINUE_BUTTON_WIDTH_PX),
        alignSelf: 'center',
      },
    },
  })
);

export default useStyles;
